import React from "react";
import About from "../About/About";
import Header from "../Header/Header";
import { Container, Row, Col } from "react-bootstrap";
import pic from "../images/File bundle-cuate.png";
import "./Home.css";
import Typewriter from "typewriter-effect";
import { Link } from "react-scroll";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PinterestIcon from "@mui/icons-material/Pinterest";
import GitHubIcon from "@mui/icons-material/GitHub";
import Service from "../Service/Service";
import About2 from "../About/About2";
import Portfolio from "../Portfolio/Portfolio";
import Blog from "../Blog/Blog";
import Certificate from "../Certifications and Testimonials/Certificate";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
const Home = () => {
  return (
    <div className="main">
      <div className="demo-wrap" id="home">
        <Header />
        <div className="demo-content">
          <Container className="details">
            <Row>
              <Col lg={8} md={8} className="content1">
                <div>
                  <h1 style={{ fontSize: "3vw", textAlign: "left" }}>
                    Hello
                    <br />
                    I'm Al Shadab Arnab a{" "}
                    <span style={{ color: "#DC965A", marginLeft: "10px" }}>
                      <Typewriter
                        options={{
                          strings: [
                            "Website Designer",
                            "Website Developer",
                            "Graphic Designer",
                          ],
                          autoStart: true,
                          loop: true,
                        }}
                      />
                    </span>
                  </h1>
                  <button className="font">
                    <Link
                      to="about"
                      spy={true}
                      smooth={true}
                      offset={-60}
                      duration={100}
                    >
                      Read More
                    </Link>
                  </button>
                </div>
              </Col>
              <Col lg={4} md={4} className="content2">
                <img
                  className="img-fluid"
                  style={{ width: "500px" }}
                  src={pic}
                  alt="bg"
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="icons">
          <div className="tag">
            <a
              href="https://www.facebook.com/alshadab.arnab/"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookIcon style={{ fontSize: "36px" }} />
            </a>
            <a
              href="https://www.instagram.com/alshadab.arnab/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <InstagramIcon style={{ fontSize: "40px" }} />
            </a>
            <a
              href="https://www.linkedin.com/in/al-shadab-arnab-12ba891b0"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon style={{ fontSize: "40px" }} />
            </a>
            <a
              href="https://www.pinterest.com/alshadabarnab13965/"
              target="_blank"
              rel="noreferrer"
            >
              <PinterestIcon style={{ fontSize: "40px" }} />
            </a>
            <a
              href="https://github.com/alshadab"
              target="_blank"
              rel="noreferrer"
            >
              <GitHubIcon style={{ fontSize: "40px" }} />
            </a>
          </div>
        </div>
      </div>
      <About />
      <About2 />
      <Service />
      <Portfolio />
      <Blog />
      <Certificate />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
